<template>
    <div class="Privacypolicy">
<h1>Privacy & Terms</h1>
<p class="PNT">
    Your privacy is important to us. It is KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE's policy to respect your privacy regarding any information we may collect from you across our website, https://www.kashinetralaya.com/, and other sites we own and operate.
<br><br>
We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.
<br><br>
We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.
<br><br>
We don’t share any personally identifying information publicly or with third-parties, except when required to by law.
<br><br>
Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.
<br><br>
You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.
<br><br>
Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.
<br><br>
This policy is effective as of 1 December 2023.
</p>

<h1>Terms of Service</h1>

<p class="PNT">
    <span>Terms</span>
    <br><br>
By accessing the website at https://www.kashinetralaya.com/, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.
<br><br>
<span>Use Licence</span>
<br><br>
Permission is granted to temporarily download one copy of the materials (information or software) on KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE’s website for personal, non-commercial transitory viewing only. This is the grant of a licence, not a transfer of title, and under this licence you may not:
<br><br>
<span>modify or copy the materials</span>
<br><br>
use the materials for any commercial purpose, or for any public display (commercial or non-commercial);
<br><br>
attempt to decompile or reverse engineer any software contained on KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE’s website;
<br><br>
remove any copyright or other proprietary notations from the materials; or
<br><br>
transfer the materials to another person or “mirror” the materials on any other server.
<br><br>
This licence shall automatically terminate if you violate any of these restrictions and may be terminated by KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE at any time. Upon terminating your viewing of these materials or upon the termination of this licence, you must destroy any downloaded materials in your possession whether in electronic or printed format.
<br><br>
<span>Disclaimer</span>
<br><br>
The materials on KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE’s website are provided on an ‘as is’ basis. KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
<br><br>
Further, KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.
<br><br>
<span>Limitations</span>
<br><br>
In no event shall KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE’s website, even if KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE or a KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE authorised representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
<br><br>
<span>Accuracy of materials</span>
<br><br>
The materials appearing on KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE’s website could include technical, typographical, or photographic errors. KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE does not warrant that any of the materials on its website are accurate, complete or current. KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE may make changes to the materials contained on its website at any time without notice. However KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE does not make any commitment to update the materials on an ongoing basis.
<br><br>
<span>Links</span>
<br><br>
KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE of the site. Use of any such linked website is at the user’s own risk.
<br><br>
<span>Modifications</span>
<br><br>
KASHI NETRALAYA EYE CARE AND LASIK LASER CENTRE may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
<br><br>
<span>Governing Law</span>
<br><br>
These terms and conditions are governed by and construed in accordance with the laws of Uttar Pradesh, India and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
</p>
</div>
</template>

<script>
export default{
    name:'PrivacyPolicy',
}
</script>

<style>
.Privacypolicy{
    text-align: left;
    padding: 40px;
    font-family: 'Montserrat';
}

.Privacypolicy h1{
    text-align: center;
}

.PNT{
    font-size: 20px;
    padding: 20px;
    text-align: left;
}

span{
    text-align: left;
    font-weight: 600;
}

</style>